export interface MediaItem {
  id: string;
  name: string;
  category: string;
  subcategory: string;
  industry: string;
  region: string;
  portal: string;
  entryLevel: string;
  inclusionStatus: string;
  linkType: string;
  publishSpeed: string;
  pcWeight: number;
  mobileWeight: number;
  publishTime: string;
  outRate: number;
  price: number;
  note: string;
  tag?: string;
}

const p = <T>(arr: T[], i: number): T => arr[Math.abs(i) % arr.length];

const industries = ['IT科技','游戏网站','财经资讯','汽车网站','娱乐休闲','新闻资讯','健康医疗','房产家居','亲子母婴','教育培训','食品餐饮','酒店旅游','女性时尚','生活消费','公益','体育运动','工业贸易','文化艺术'];
const portals = ['其他门户','综合门户','腾讯网','新浪网','网易网','搜狐网','凤凰网','人民网','行业门户'];
const entryLevels = ['没有入口','首页入口','频道入口','上级入口'];
const inclusionStatuses = ['不包周页收录','包周页收录','不包资讯收录','包资讯收录'];
const linkTypes = ['不可带网址','可带网址'];
const publishSpeeds = ['1小时','2小时','12小时','当日','次日','48小时以上'];
const publishTimes = ['1小时','2小时','4小时','6小时','12小时','24小时','当日','6小时10分钟','8小时','48小时'];
const regions = ['综合全国','北京','上海','广东','浙江','江苏','湖北','四川','重庆','陕西','天津','河南','湖南','安徽','山东','福建','辽宁','河北','吉林','云南','贵州','山西','黑龙江','广西','江西','甘肃'];
const notes = [
  '博客国家方账号，AI收录好，不发医疗保健，可以带联系方式，欢迎下单',
  '出稿快，个别稿件改不通知',
  '地方权威媒体，收录稳定，不接受违法违规内容',
  '综合类门户，流量稳定，适合品牌推广',
  '行业垂直媒体，精准流量，SEO权重高',
  '不接受纯广告内容，需要有实质性信息价值',
  '不接医疗、金融监管严格类内容，欢迎长期合作',
  '收录快，出稿稳定，欢迎合作',
  '专注本地新闻，地域用户精准',
  '知名财经媒体，公信力强，不接负面内容',
  '科技类垂直媒体，适合科技企业宣传',
  '综合全国媒体，覆盖面广，SEO效果佳',
  '接受企业资讯、行业动态、产品发布类文章',
  '权威媒体背书，品牌传播首选，需提前预约',
];
const tags = ['企业快讯','科技企业','健康医疗','财经资讯','文化传媒','教育培训','地方权威','行业垂直'];
const prices = [8,10,12,15,18,20,22,25,28,30,35,40,45,50,60,80,100,120,150,200,250,300,500];
const cats = ['新闻资讯','财经资讯','IT科技','娱乐休闲','健康医疗','房产家居','汽车资讯','教育资讯','行业资讯','体育资讯'];

function mk(id: string, name: string, i: number, region: string, industry: string, cat: string, sub: string): MediaItem {
  return {
    id, name, category: cat, subcategory: sub, industry, region,
    portal: p(portals, i),
    entryLevel: p(entryLevels, i),
    inclusionStatus: p(inclusionStatuses, i),
    linkType: p(linkTypes, i),
    publishSpeed: p(publishSpeeds, i),
    pcWeight: (i % 9) + 1,
    mobileWeight: (i % 8) + 1,
    publishTime: p(publishTimes, i),
    outRate: 70 + (i % 26),
    price: p(prices, i),
    note: p(notes, i),
    tag: i % 7 === 0 ? p(tags, i) : undefined,
  };
}

const nationalNames = [
  '腾讯新闻','新浪新闻','网易新闻','搜狐新闻','凤凰资讯','人民网','新华网','央视网',
  '中国新闻网','中国日报网','光明网','中国青年网','环球网','北青网','中国经济网',
  '国际在线','中国网','中华网','东方网','大众网','第一财经','财新网','21世纪经济报道',
  '证券时报','上海证券报','中国证券报','经济参考报','金融时报','中国金融网','和讯财经',
  '雪球财经','同花顺财经','东方财富','格隆汇','华尔街见闻','彭博商业周刊','IT之家',
  '36氪','虎嗅网','钛媒体','创业邦','猎云网','雷锋网','极客公园','爱范儿','科技日报',
  '中国科技网','半导体行业观察','芯智讯','电子工程世界','汽车之家','汽车头条','易车网',
  '懂车帝','太平洋汽车','中国汽车报','丁香医生','医学界','健康界','中国医学论坛报',
  '中国建设报','中国房地产报','中国教育报','中国教育在线','人民体育','中国体育报',
  '体坛周报','人民文化','中国文化报','艺术中国网','中国旅游网','第一旅游网','中国食品报',
  '中国化工报','中国能源报','中国工业报','中国制造网',
];

const cities = [
  ['北京','北京'],['上海','上海'],['广州','广东'],['深圳','广东'],['杭州','浙江'],
  ['南京','江苏'],['武汉','湖北'],['成都','四川'],['重庆','重庆'],['西安','陕西'],
  ['天津','天津'],['苏州','江苏'],['郑州','河南'],['长沙','湖南'],['合肥','安徽'],
  ['宁波','浙江'],['济南','山东'],['福州','福建'],['厦门','福建'],['青岛','山东'],
  ['南宁','广西'],['太原','山西'],['石家庄','河北'],['哈尔滨','黑龙江'],['沈阳','辽宁'],
  ['长春','吉林'],['昆明','云南'],['贵阳','贵州'],['南昌','江西'],['兰州','甘肃'],
  ['银川','宁夏'],['呼和浩特','内蒙古'],['海口','海南'],['咸宁','湖北'],['襄阳','湖北'],
  ['荆州','湖北'],['宜昌','湖北'],['温州','浙江'],['嘉兴','浙江'],['扬州','江苏'],
];
const cityMediaTypes = ['新闻网','日报','在线','信息港','传媒'];

const industryMediaNames: [string, string][] = [
  ['中国汽车报','汽车网站'],['汽车商报','汽车网站'],['汽车观察','汽车网站'],['汽车品质','汽车网站'],
  ['中国食品报','食品餐饮'],['食品安全导刊','食品餐饮'],['餐饮世界','食品餐饮'],['美食中国','食品餐饮'],
  ['中国医药报','健康医疗'],['健康报','健康医疗'],['医药经济报','健康医疗'],['中国中医药报','健康医疗'],
  ['中国教育报','教育培训'],['教育时报','教育培训'],['现代教育报','教育培训'],['教育信息化','教育培训'],
  ['中国建设报','房产家居'],['家居世界','房产家居'],['中国房地产报','房产家居'],['居住中国','房产家居'],
  ['中国体育报','体育运动'],['足球报','体育运动'],['体坛周报','体育运动'],['户外探险','体育运动'],
  ['中国旅游报','酒店旅游'],['旅游世界','酒店旅游'],['中国酒店','酒店旅游'],['酒店职业经理人','酒店旅游'],
  ['计算机世界','IT科技'],['网络世界','IT科技'],['互联网周刊','IT科技'],['AI科技大本营','IT科技'],
  ['大数据观','IT科技'],['云计算世界','IT科技'],['机器之心','IT科技'],['PingWest品玩','IT科技'],
  ['中国游戏产业报告','游戏网站'],['游戏陀螺','游戏网站'],['游戏葡萄','游戏网站'],['手游那点事','游戏网站'],
  ['第一财经日报','财经资讯'],['中国金融报','财经资讯'],['理财周报','财经资讯'],['北京商报','财经资讯'],
  ['经济日报','财经资讯'],['国际商报','财经资讯'],['中国贸易报','工业贸易'],['中国工业报','工业贸易'],
  ['工业信息化','工业贸易'],['中国纺织报','工业贸易'],['中国化工报','工业贸易'],
  ['中国妇女报','女性时尚'],['时尚芭莎','女性时尚'],['瑞丽时尚','女性时尚'],['美妆大赏','女性时尚'],
  ['亲子天地','亲子母婴'],['中国母婴','亲子母婴'],['母婴周刊','亲子母婴'],['优生优育','亲子母婴'],
  ['公益时报','公益'],['中国公益新闻网','公益'],['善达网','公益'],['中国环境报','公益'],
  ['中国文化报','文化艺术'],['艺术市场','文化艺术'],['中国书画报','文化艺术'],['中国摄影报','文化艺术'],
  ['中国娱乐报道','娱乐休闲'],['娱乐资讯网','娱乐休闲'],['星娱乐','娱乐休闲'],['影视前沿','娱乐休闲'],
  ['生活日报','生活消费'],['消费者报道','生活消费'],['中国消费者报','生活消费'],['生活时报','生活消费'],
  ['扬子晚报数字版','新闻资讯'],['南方都市报','新闻资讯'],['北京晚报','新闻资讯'],['广州日报','新闻资讯'],
  ['浙江日报','新闻资讯'],['湖南日报','新闻资讯'],['四川日报','新闻资讯'],['陕西日报','新闻资讯'],
  ['大连晚报','新闻资讯'],['沈阳晚报','新闻资讯'],['哈尔滨日报','新闻资讯'],['长春日报','新闻资讯'],
];

function generateMediaList(): MediaItem[] {
  const items: MediaItem[] = [];
  let idx = 0;
  nationalNames.forEach((name, i) => {
    const ind = p(industries, i);
    items.push(mk(`n${i}`, name, idx++, '综合全国', ind, p(cats, i), p(portals, i)));
  });
  cities.forEach(([city, region]) => {
    cityMediaTypes.forEach((type, j) => {
      const i = idx++;
      items.push(mk(`c${i}`, `${city}${type}`, i, region, p(industries, i + j), '新闻资讯', '其他门户'));
    });
  });
  industryMediaNames.forEach(([name, ind], i) => {
    const ri = idx++;
    items.push(mk(`ind${ri}`, name, ri, p(regions, ri), ind, ind === 'IT科技' ? 'IT科技' : '行业资讯', '行业门户'));
  });
  return items;
}

export const geoMediaList: MediaItem[] = generateMediaList();
